import { useCallback } from "react";
import { useIntl } from "react-intl";
import { useAlert } from "../../../../common/Alert";

export function useDeleteWigetAlert({
  onDelete,
  widgetIsShared,
  renderContext,
}: {
  renderContext: "space" | "storecast";
  onDelete(id: string): void;
  widgetIsShared: boolean;
}) {
  const intl = useIntl();
  const Alert = useAlert();
  return useCallback(
    (id: string) => {
      const title = widgetIsShared
        ? renderContext === "storecast"
          ? intl.formatMessage({
              defaultMessage: "Remove widget from this StoreCast?",
              description: "useDeleteWidgetAlert alert title shared widget",
            })
          : intl.formatMessage({
              defaultMessage: "Remove widget from this Space?",
              description:
                "useDeleteWidgetAlert alert title shared widget space",
            })
        : intl.formatMessage({
            defaultMessage: "Do you want to remove this widget?",
            description: "useDeleteWidgetAlert alert title",
          });

      const subtitle = widgetIsShared
        ? intl.formatMessage({
            defaultMessage:
              "This widget is shared with other StoreCasts. It will only be removed from this StoreCast.",
            description: "useDeleteWidgetAlert alert shared subtitle",
          })
        : undefined;
      Alert.alert(
        title,
        subtitle,
        [
          {
            onPress: () => {
              onDelete(id);
            },
            style: "destructive",
            text: intl.formatMessage({
              defaultMessage: "Remove widget",
              description: "useDeleteWidgetAlert alert option remove widget",
            }),
          },
          {
            onPress: () => {},
            style: "cancel",
            text: intl.formatMessage({
              defaultMessage: "Cancel",
              description: "useDeleteWidgetAlert alert option cancel",
            }),
          },
        ],
        {}
      );
    },
    [Alert, intl, onDelete, renderContext, widgetIsShared]
  );
}
